import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromReviewerInteraction from './reducers/reviewer-interaction.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ReviewerInteractionEffects } from './effects/reviewer-interaction.effects';
import { ReviewerInteractionsService } from './services/reviewer-interactions.service';
import { ReviewerInteractionFacade } from './facades/reviewer-interaction.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromReviewerInteraction.reviewerInteractionFeatureKey,
      fromReviewerInteraction.reducer
    ),
    EffectsModule.forFeature([ReviewerInteractionEffects]),
  ],
  providers: [ReviewerInteractionsService, ReviewerInteractionFacade],
})
export class ReviewerInteractionStoreModule {}
